// extracted by mini-css-extract-plugin
export default {"FeatureListContainer":"_FeatureListContainer--IFNF9","Header":"_Header--LbiR1","FeatureList":"_FeatureList--hYQQn"};